// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".polygon:hover{background-color:red!important}.polygons-area{position:absolute}.noselect{-webkit-touch-callout:none!important;-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}", ""]);
// Exports
module.exports = exports;
